export default function usePopupState({ id, anchorEl }) {
  const open = Boolean(anchorEl);
  const newId = open ? id || 'simple-popper' : undefined;
  return { open, newId };
}
